export default "__VITE_ASSET__81d944cd__"